import { DemandPollApi } from 'api/DemandPollApi';
import { backendApiClient } from 'container/backendApiClient';

export const demandPollApi = new DemandPollApi(backendApiClient);
